import React from "react";
import { useTranslate } from "../i18n";
import { useTheme } from "../contexts/ThemeContext";
import { IcoMoon, IcoSun } from "./layoutIcons";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const { t } = useTranslate();
  const isDark = theme === "dark";
  const label = isDark ? t("layout.theme.lightMode") : t("layout.theme.darkMode");

  return (
    <button
      onClick={toggle}
      className="e-icon-target"
      aria-label={label}
      title={label}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 36,
        height: 36,
        borderRadius: 8,
        background: "var(--surface-md)",
        border: "1px solid var(--border)",
        color: "var(--muted2)",
        cursor: "pointer",
        flexShrink: 0,
        transition: "background 0.15s, color 0.15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "var(--hover-bg-md)";
        e.currentTarget.style.color = "var(--text)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "var(--surface-md)";
        e.currentTarget.style.color = "var(--muted2)";
      }}
    >
      {isDark ? <IcoSun /> : <IcoMoon />}
    </button>
  );
}
